// A cookie read/write can throw (e.g. document.cookie access inside a sandboxed iframe missing
// allow-same-origin — the campaign page is embeddable via /iframe/{campaign}). That should never
// crash the surrounding page; the caller gets the fallback value instead.
const safely = (operation, fallback) => {
    try {
        return operation();
    }
    catch (_a) {
        return fallback;
    }
};
export default safely;
